/* Khong hieu sao phai cho menu ra ngoai file rieng thi moi o duoi appbar */
import * as React from "react";
import { Menu, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  MenuItem,
  Divider,
  ListItemIcon,
  ListItemText,
  Button,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import TimelineIcon from "@mui/icons-material/Timeline";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AssignmentIcon from "@mui/icons-material/Assignment";

const useStyles = makeStyles((theme) => ({
  menuText: {
    color: "white",
  },
  menuIcon: {
    color: "white",
  },
}));

export default function MenuPrint(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        variant="contained"
        color={props.color ? props.color : "primary"}
        disabled={props.disabled}
        fullWidth={props.fullWidth ? true : false}
        onClick={handleClick}
      >
        {props.title === undefined ? "In GCN" : props.title}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            if (props.onClick) {
              props.onClick({
                name: "pdf",
                title: "Cấp GCN Định biên",
              });
            }
            handleClose();
          }}
        >
          <ListItemIcon>
            <EmojiPeopleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>In PDF</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            if (props.onClick) {
              props.onClick({
                name: "word",
                title: "Cấp GCN CLC",
              });
            }
            handleClose();
          }}
        >
          <ListItemIcon>
            <LibraryBooksIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Xuất file Word</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            if (props.onClick) {
              props.onClick({
                name: "excel",
                title: "Cấp GCN lý lịch tàu",
              });
            }
            handleClose();
          }}
        >
          <ListItemIcon>
            <TimelineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Xuất file Excel</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            if (props.onClick) {
              props.onClick({
                name: "pdf2",
                title: "Cấp GCN lý lịch tàu",
              });
            }
            handleClose();
          }}
        >
          <ListItemIcon>
            <AssignmentIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Xuất file ký số</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
